import middelware from "./middelware";

const routes = [
  {
    path: "/admin",
    component: () => import("@/views/layout/AdminLayout"),
    beforeEnter: [middelware.authenticated, middelware.isAdmin],
    redirect: "/admin/user",
    children: [
      {
        path: "user",
        component: () => import("@/views/admin/user/AdminUser"),
        children: [
          {
            path: "",
            component: () => import("@/views/admin/user/AdminUserList"),
          },
          {
            path: ":userId",
            component: () => import("@/views/admin/user/AdminUserDetail"),
          },
        ],
      },
      {
        path: "board",
        component: () => import("@/views/admin/board/AdminBoard"),
        redirect: "/admin/board/lecture",
        children: [
          {
            path: "lecture",
            component: () => import("@/views/admin/board/lecture/AdminLecture"),
            children: [
              {
                path: "",
                component: () => import("@/views/admin/board/lecture/AdminLectureList"),
              },
              {
                path: "create",
                component: () => import("@/views/admin/board/lecture/AdminLectureCreate"),
              },
              {
                path: ":lectureId",
                component: () => import("@/views/admin/board/lecture/AdminLectureDetail"),
              },
            ],
          },
          {
            path: "beauty",
            component: () => import("@/views/admin/board/beauty/AdminBeauty"),
            children: [
              {
                path: "",
                component: () => import("@/views/admin/board/beauty/AdminBeautyList"),
              },
              {
                path: "create",
                component: () => import("@/views/admin/board/beauty/AdminBeautyCreate"),
              },
              {
                path: ":beautyId",
                component: () => import("@/views/admin/board/beauty/AdminBeautyDetail"),
              },
            ],
          },
          {
            path: "review",
            component: () => import("@/views/admin/board/review/AdminReview"),
            children: [
              {
                path: "",
                component: () => import("@/views/admin/board/review/AdminReviewList"),
              },
              {
                path: "create",
                component: () => import("@/views/admin/board/review/AdminReviewCreate"),
              },
              {
                path: ":reviewId",
                component: () => import("@/views/admin/board/review/AdminReviewDetail"),
              },
            ],
          },
          {
            path: "b4a",
            component: () => import("@/views/admin/board/b4a/AdminB4A"),
            children: [
              {
                path: "",
                component: () => import("@/views/admin/board/b4a/AdminB4AList"),
              },
              {
                path: "create",
                component: () => import("@/views/admin/board/b4a/AdminB4ACreate"),
              },
              {
                path: ":b4aId",
                component: () => import("@/views/admin/board/b4a/AdminB4ADetail"),
              },
            ],
          },
        ],
      },
      {
        path: "counsel",
        component: () => import("@/views/admin/counsel/AdminCounsel"),
        children: [
          {
            path: "",
            component: () => import("@/views/admin/counsel/AdminCounselList"),
          },
          {
            path: ":counselId",
            component: () => import("@/views/admin/counsel/AdminCounselDetail"),
          },
        ],
      },
    ],
  },
];

export default routes;
